import React from "react";

// Consistent empty / no-results / error panel for TSP lists and pages.
// tone "error" is announced immediately (role=alert); the others politely.
export default function TspEmptyState({ icon: Icon, title, message, action, tone = "neutral" }) {
  return (
    <div className={`tsp-empty tsp-empty-${tone}`} role={tone === "error" ? "alert" : "status"}>
      {Icon && (
        <span className="tsp-empty-icon" aria-hidden="true">
          <Icon size={26} />
        </span>
      )}
      <h4 className="tsp-empty-title">{title}</h4>
      {message && <p className="tsp-empty-message">{message}</p>}
      {action && <div className="tsp-empty-action">{action}</div>}
    </div>
  );
}
